import { type PropsWithChildren } from "react";
import { Navigate, useLocation } from "react-router";

import { useSession } from "@vega-api/custom/SessionContext";
import { isTruthy } from "@vega-core/utils/isTruthy";

import { CommonPaths } from "../../paths";

import { ErrorBoundary } from "./ErrorBoundary";

export const PublicRoute = ({ children }: PropsWithChildren) => {
  const location = useLocation();
  const session = useSession();

  if (isTruthy(session.user)) {
    return <Navigate replace to={CommonPaths.Home} />;
  }

  return (
    <ErrorBoundary isPublicPage locationKey={location.pathname}>
      {children}
    </ErrorBoundary>
  );
};
